import type { RootState } from '@/app/store';

export const selectProductionPeriodData = (state: RootState) =>
  state.productionPeriod.productionPeriodData;
export const selectProductionPeriodLoading = (state: RootState) =>
  state.productionPeriod.productionPeriodListLoading;
export const selectProductionPeriodError = (state: RootState) =>
  state.productionPeriod.error;
export const selectProductionPeriodDetailData = (state: RootState) =>
  state.productionPeriod.productionPeriodDetailData;
export const selectProductionPeriodDetailLoading = (state: RootState) =>
  state.productionPeriod.productionPeriodDetailLoading;
export const selectProductionPeriodDetailError = (state: RootState) =>
  state.productionPeriod.detailError;
export const selectProductionPeriodCreating = (state: RootState) =>
  state.productionPeriod.createProductionPeriodLoading;
export const selectProductionPeriodCreateError = (state: RootState) =>
  state.productionPeriod.createError;
export const selectProductionPeriodCreateResult = (state: RootState) =>
  state.productionPeriod.createResult;
export const selectProductionPeriodUpdating = (state: RootState) =>
  state.productionPeriod.updateProductionPeriodLoading;
export const selectProductionPeriodUpdateError = (state: RootState) =>
  state.productionPeriod.updateError;
export const selectProductionPeriodUpdateResult = (state: RootState) =>
  state.productionPeriod.updateResult;
export const selectProductionPeriodDeleting = (state: RootState) =>
  state.productionPeriod.deleteProductionPeriodLoading;
export const selectProductionPeriodDeleteError = (state: RootState) =>
  state.productionPeriod.deleteError;
export const selectProductionPeriodDeleteResult = (state: RootState) =>
  state.productionPeriod.deleteResult;
